import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles(({ palette, spacing }) => ({
  root: {
    margin: spacing(1),
    color: palette.error.main
  }
}));

const TextError = ({ children }) => {
  const classes = useStyles({})
;
  return (
    <Typography className={classes.root} variant="caption" align="center" gutterBottom>
      {children}
    </Typography>
  );
};

export default TextError;
